import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TicketHeader from "./TicketHeader";
import ReportsTable from "../Reports/ReportsTable";
import { ApiHook } from "../../hooks/apiHook";

const Reports = () => {
    const { t }    = useTranslation();
    const navigate = useNavigate();
    const [itemsPerPage,    setItemsPerPage]    = useState(10);
    const [currentPage,     setCurrentPage]     = useState(1);
    const [selectedOptions, setSelectedOptions] = useState({
        trackId:          "",
        selectedCategory: "",
        selectedStatus:   "",
    });

    const reports = ApiHook.CallReports(
        currentPage,
        itemsPerPage,
        selectedOptions.selectedCategory,
        selectedOptions.selectedStatus,
        selectedOptions.trackId,
    );

    return (
        <>
            <div className="page_head_top">{t("reports")}</div>
            <TicketHeader />
            <div className="d-flex justify-content-end mt-3 mb-2">
                <button
                    className="btn btn-primary"
                    onClick={() => navigate("/create-report")}
                >
                    <i className="fa-solid fa-plus me-1"></i> {t("create_report")}
                </button>
            </div>
            <ReportsTable
                data={reports?.data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
            />
        </>
    );
};

export default Reports;
